module.exports = __webpack_public_path__ + "static/media/3-88Holidays.e7947a7b.png";